import Footer from "../components/Footer";

export default function CareGuidePage() {
  return (
    <main data-testid="care-page" className="bg-[#0A0A0A] min-h-screen pt-[100px]">
      <div className="max-w-3xl mx-auto px-6 md:px-10 py-14">
        <div
          className="font-ui mb-3"
          style={{ fontSize: 12, fontWeight: 600, color: "#F5D565", letterSpacing: "0.4em", textTransform: "uppercase" }}
        >
          ✦ Care
        </div>
        <h1
          className="font-serif-display"
          style={{ fontSize: 56, color: "#FFFFFF", lineHeight: 0.95, fontWeight: 500, letterSpacing: "-0.01em" }}
        >
          The Edge,
          <br />
          <em className="not-italic gold-text font-light">Preserved.</em>
        </h1>

        <p
          className="font-body mt-8"
          style={{ fontSize: 16, color: "rgba(255,255,255,0.85)", lineHeight: 1.65 }}
        >
          Your Her Box pieces are crafted with skin-friendly materials. Treat them like your secrets.
        </p>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 gap-10">
          <div>
            <div
              className="font-ui mb-3"
              style={{ fontSize: 14, fontWeight: 600, color: "#F5D565", letterSpacing: "1px" }}
            >
              Do
            </div>
            <ul className="space-y-3 font-body" style={{ fontSize: 16, color: "rgba(255,255,255,0.85)", lineHeight: 1.6 }}>
              <li>· Store in the soft Edge Box, away from moisture.</li>
              <li>· Put on after perfume.</li>
              <li>· Wipe with a soft cloth after wear.</li>
            </ul>
          </div>
          <div>
            <div
              className="font-ui mb-3"
              style={{ fontSize: 14, fontWeight: 600, color: "#F5D565", letterSpacing: "1px" }}
            >
              Don't
            </div>
            <ul className="space-y-3 font-body" style={{ fontSize: 16, color: "rgba(255,255,255,0.85)", lineHeight: 1.6 }}>
              <li>· Swim, shower, or sweat heavy in them.</li>
              <li>· Spray perfume directly.</li>
              <li>· Use harsh chemicals.</li>
            </ul>
          </div>
        </div>

        <p
          className="font-body mt-12 italic"
          style={{ fontSize: 16, color: "rgba(255,255,255,0.7)" }}
        >
          This keeps the gold warm and your edge sharp.
        </p>
      </div>
      <Footer />
    </main>
  );
}
